import React from 'react';
import './Layout.css';

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <div className="layout-container">
        <header className="layout-header">
          <h1 className="layout-logo">ANEW Aesthetic</h1>
          <p className="layout-tagline">당신의 아름다움을 새롭게</p>
        </header>
        
        <main className="layout-main">
          {children}
        </main>
        
        <footer className="layout-footer">
          <p>© 2024 ANEW Aesthetic. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default Layout;
